import { render, staticRenderFns } from "./SidebarSwitch.vue?vue&type=template&id=23600186&scoped=true&"
var script = {}
import style0 from "./SidebarSwitch.vue?vue&type=style&index=0&id=23600186&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23600186",
  null
  
)

export default component.exports